<!-- @format -->

<template>
	<li v-if="divided" class="pc-contextmenu__divided" />
	<li
		v-else
		class="pc-contextmenu__item"
		:class="classes"
		@mouseenter="handleMouseEnter"
		@mouseleave="handleMouseLeave"
		@click.prevent.stop="handleClick"
	>
		<div class="ibps-contextmenu__left">
			<!-- 图标-->
			<!-- <template v-if="icon">
        <template v-if="iconTypes=='font'">
          <span v-if="iconProps" class="pc-contextmenu__font-icon">
            <ibps-icon v-bind="iconProps" />
          </span>
        </template>
        <icon-park
          v-else
          :type="icon"
          size="20"
          :fill="[fixedColor]"
          class="pc-contextmenu__svg-icon"
        />
      </template> -->
			<span
				class="pc-contextmenu__label"
				:class="{
					[`pc-contextmenu__label--${type}`]: !(type === '' && type === undefined),
				}"
				:style="{ color: fixedColor !== '' ? fixedColor : 'auto' }"
				>{{ label }}</span
			>
		</div>
		<div v-if="info && hasChild" class="ibps-contextmenu__right">
			<span v-if="info" class="pc-contextmenu__info">{{ info }}</span>
			<i v-if="hasChild" class="pc-contextmenu__arrow el-icon-caret-right" />
		</div>
		<slot v-if="active" :active="active" :children="children" />
	</li>
</template>

<script>
	import { $utils } from '@/utils/publicUtils';
	export default {
		props: {
			icon: [String, Object],
			iconType: String,
			label: String,
			info: String,
			disabled: Boolean,
			divided: Boolean,
			children: Array,
			type: String,
			color: String,
		},
		data() {
			return {
				active: false,
				fixedColor: this.color,
				theme: '',
			};
		},
		computed: {
			iconProps() {
				if (!this.icon) return null;
				return typeof this.icon === 'object'
					? $utils.isNotEmpty(this.icon.name)
						? this.icon
						: null
					: {
							name: this.icon,
					  };
			},
			iconTypes() {
				if (typeof this.icon === 'object') {
					return this.icon.iconType || this.iconType || 'svg';
				} else {
					return this.iconType || 'svg';
				}
			},
			classes() {
				return {
					'is-disabled': this.disabled,
					'is-has-child': this.hasChild,
				};
			},
			hasChild() {
				return this.children && this.children.length > 0;
			},
		},
		methods: {
			handleMouseEnter() {
				!this.disabled ? (this.fixedColor = this.theme) : null;
				this.active = true;
				if (this.hasChild) {
					this.$nextTick(() => {
						this.$emit('submenu', this);
					});
				}
			},
			handleMouseLeave() {
				!this.disabled ? (this.fixedColor = this.color) : null;
				this.active = false;
			},
			handleClick() {
				if (this.disabled) {
					return;
				}
				// this.$emit('click', this)
			},
		},
	};
</script>
